import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = {
  orgRemoveLoading: false,
  orgRemoveError: null,
  removedImage: null,
};

export function orgImageRemove(state = initialState, action) {
  switch (action.type) {
    case organisationConstants.ORG_REQUEST_DELETE_UPLOAD:
      return {
        ...state,
        orgRemoveLoading: true,
        orgRemoveError: null,
      };
    case organisationConstants.ORG_RESPONSE_DELETE_UPLOAD:
      return {
        ...state,
        orgRemoveLoading: false,
        orgRemoveError: null,
        removedImage: action.removedImage,
      };
    case organisationConstants.ORG_ERROR_DELETE_UPLOAD:
      return {
        ...state,
        orgRemoveLoading: false,
        orgRemoveError: action.error,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/orgImageRemove.reducer.js